export const engagementCanvasesWithRepliedToSms = "/engagement/canvases_with_replied_to_sms";
